import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mag5",
  "use": "icon-mag5-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mag5\"><path d=\"M928.48 772.27H104.75a34.19 34.19 0 0 1-34.15-34.15V174.35a34.19 34.19 0 0 1 34.15-34.15h823.73a34.19 34.19 0 0 1 34.15 34.15v563.77a34.19 34.19 0 0 1-34.15 34.15zM134.89 708h763.45V204.49H134.89zM160.25 819.51h712.73v64.29H160.25z\" p-id=\"6975\" /><path d=\"M448.69 339.69h364.54v64.29H448.69zM448.69 517.42h364.54v64.29H448.69zM251.61 457.69l-58.8-74.53 50.48-39.82 19.07 24.16 93.4-73.34 39.71 50.56-143.86 112.97zM251.61 644.01l-58.8-74.54 50.48-39.82 19.07 24.17 93.4-73.34 39.71 50.56-143.86 112.97z\" p-id=\"6976\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-mag5.svg
// module id = 6iyZ
// module chunks = 120